"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("./utils");

var _default = _react.default.createClass({
  displayName: "FormattedMessage",
  mixins: [_utils.I18nCommonMixin],
  propTypes: _utils.commonPropTypes,
  render: function render() {
    var __message = this.props.message;
    var props = (0, _utils.classNameFix)((0, _utils.getPassThroughProps)(this.props));
    return _react.default.createElement("i18n-string", props, this._getValue(true));
  }
});

exports.default = _default;
module.exports = exports.default;